import { clsxMerge } from "shared/lib/helpers/styles";
import { Avatar } from "shared/ui";
import { BorderWithGradient } from "shared/ui/border-with-gradient";
import RenderHTML from "shared/ui/render-html";
import { ScrollArea } from "shared/ui/shadcn/scroll-area";
import { Separator } from "shared/ui/shadcn/separator";

interface EmailHistoryCardPropsI {
  isSentByAI?: boolean;
  contact_name?: string;
  to_email?: string;
  subject?: string;
  body?: string;
}

const EmailHistoryCardWrapper = ({
  isSentByAI,
  children,
}: {
  isSentByAI?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <BorderWithGradient
      isBorderDisabled={!isSentByAI}
      className="p-5"
      containerClassName={clsxMerge("flex-1 bg-white", {
        "rounded-md border-2 border-[#E5E7FF]": !isSentByAI,
      })}
    >
      {children}
    </BorderWithGradient>
  );
};

const EmailHistoryCardHeader = ({
  contact_name,
  to_email,
  subject,
}: EmailHistoryCardPropsI) => {
  return (
    <div className="flex gap-3">
      <Avatar className="size-8" placeholderText={contact_name} />

      <div>
        <div className="mb-1.5 typography-body-3-medium">{contact_name}</div>
        <div className="mb-1.5 text-[#878787] typography-body-5">
          To: {to_email}
        </div>
        <div className="text-[#333333] typography-body-4">{subject}</div>
      </div>
    </div>
  );
};

export const EmailHistoryCard = ({
  isSentByAI,
  contact_name,
  to_email,
  subject,
  body,
}: EmailHistoryCardPropsI) => {
  return (
    <EmailHistoryCardWrapper isSentByAI={isSentByAI}>
      <EmailHistoryCardHeader
        contact_name={contact_name}
        to_email={to_email}
        subject={subject}
      />

      <Separator className="mb-5 mt-2" />

      <p className="mb-4 typography-body-3-bold">{subject}</p>

      <ScrollArea className="flex max-h-[278px] flex-col pr-2">
        <pre>
          {body ? (
            <RenderHTML
              className="text-wrap break-words text-black/80 typography-body-4"
              html={body}
            />
          ) : (
            <p className="typography-body-4">Email content is not available.</p>
          )}
        </pre>
      </ScrollArea>
    </EmailHistoryCardWrapper>
  );
};
